// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__h9Qij","title":"error_title__Y_jOJ","subtitle":"error_subtitle__mYsnZ","description":"error_description__wHCk2"};